import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=d38b7104&scoped=true&"
import script from "./Section8.vue?vue&type=script&lang=js&"
export * from "./Section8.vue?vue&type=script&lang=js&"
import style0 from "./Section8.vue?vue&type=style&index=0&id=d38b7104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b7104",
  null
  
)

export default component.exports